  document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    console.log(window._klOnsite);

    if (urlParams.has("notify")) {
       let btn = document.querySelectorAll('.product-form .klaviyo-bis-trigger');
       console.log(btn)
      if( btn.length > 0 ) {
        setTimeout(() => {
          btn[0].click();
        }, 800)
      }
    }
});